import TemplateNames from './TemplateNames';

export default {
  title: 'Sendte beskeder',
  columns: {
    recipient: 'Modtager',
    template: 'Skabelon',
    status: 'Status',
    opened: 'Åbnet',
    clicked: 'Klikket',
    sent_at: 'Sendt den',
  },
  labels: {
    empty_list: 'Ingen sendte beskeder endnu',
    load_failed: 'Kunne ikke indlæse dine sendte beskeder. Genindlæs siden, eller kontakt support.',
    yes: 'Ja',
    no: 'Nej',
    clicked_at: 'Klikket: {{date}}',
    opened_at: 'Åbnet: {{date}}',
  },
  message_statuses: {
    sent: 'Sendt',
    delivered: 'Leveret',
    failed: 'Mislykkedes',
  },
  template_names: TemplateNames,
  toasts: {
    failed_to_load_data: 'Data kunne ikke indlæses',
  },
};
